'use strict';

import React from 'react';
import {Link} from 'react-router';

// const propTypes = {
//     currentUser: React.PropTypes.object
// };
class GetInvoice extends React.Component {

    constructor(props) {
        super(props);
        this.state = props.temp;

        this.getTotal=this.getTotal.bind(this);
    }

    getTotal(order) {
        var total = 0;
        for (var i = 0; i < order.length; i++) {
            total += (order[i].clientPrice) * (order[i].acceptedQuantity)
        }
        return total;
    }

    render() {
        if (true) {

            return (
                <div className="customTableInvoice" id="toDownloadPdf">
                    <header className="clearfix">
                        <div id="logo">
                            <img src="https://client.khula.co.za//images/agric_logo.svg"/>
                        </div>
                        <div id="company">
                            <h2 className="name">KHULA</h2>
                            <div>28 Bompas Road</div>
                            <div>(+27) 783890395</div>
                            <div><a href="mailto:info@khula.com">info@khula.com</a></div>
                        </div>
                    </header>
                    <main>
                        <div id="details" className="clearfix">
                            <div id="client">
                                <div className="to">INVOICE TO:</div>
                                <h2 className="name">{this.state.profile.name}</h2>
                                <div className="address">{this.state.profile.location}</div>
                                <div className="email"><a
                                    href="mailto:john@example.com">{this.state.profile.email}</a>
                                </div>
                            </div>
                            <div id="invoice">
                                <h1 id="invoiceNumber">INVOICE KL{this.state.mainKey}</h1>
                                <div className="date" id="start"></div>
                                <div className="date due">Generated Date: {(this.state.date)}</div>
                            </div>
                        </div>
                        <table border="0" cellspacing="0" cellpadding="0" className="table">
                            <thead>
                            <tr>
                                <th className="no">#</th>
                                <th className="description">PRODUCE NAME</th>
                                <th className="unit">UNIT PRICE</th>
                                <th className="qty">QUANTITY</th>
                                <th className="total">TOTAL</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.selectedOrder.map((order, i) =>
                                <tr>
                                    <td className="no">{i+1}</td>
                                    <td className="desc">{order.name}</td>
                                    <td className="unit">R{order.clientPrice}</td>
                                    <td className="qty">{order.acceptedQuantity} KGs</td>
                                    <td className="total">R{(order.clientPrice) * (order.acceptedQuantity)}</td>
                                </tr>
                            )}

                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="3"></td>
                                <td colspan="1">SUBTOTAL</td>
                                <td>R{this.getTotal(this.state.selectedOrder)}</td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <td colspan="1">VAT 0%</td>
                                <td>R0.00</td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <td colspan="1">GRAND TOTAL</td>
                                <td>R{this.getTotal(this.state.selectedOrder)}</td>
                            </tr>
                            </tfoot>
                        </table>
                        <div id="thanks">Thank you for your business!</div>

                    </main>
                </div>);
        } else {
            return (
                <div className="customTableInvoice">
                    <header className="clearfix">
                        <div id="logo">
                            <img src="https://client.khula.co.za//images/agric_logo.svg"/>
                        </div>
                        <div id="company">
                            <h2 className="name">KHULA</h2>
                            <div>455 Foggy Heights, AZ 85004, US</div>
                            <div>(+27) 11 519 0450</div>
                            <div><a href="mailto:info@khula.com">info@khula.com</a></div>
                        </div>
                    </header>
                    <main>
                        <div id="details" className="clearfix">
                            <div id="client">
                                <div className="to">INVOICE TO:</div>
                                <h2 className="name">Mathew Piper</h2>
                                <div className="address">796 Silver Harbour, TX 79273, US</div>
                                <div className="email"><a
                                    href="mailto:john@example.com">mathewpiper@moneytreegroup.com</a>
                                </div>
                            </div>
                            <div id="invoice">
                                <h1 id="invoiceNumber">INVOICE KL</h1>
                                <div className="date" id="start"></div>
                                <div className="date due">Due Date: 30/06/2014</div>
                            </div>
                        </div>
                        <table border="0" cellspacing="0" cellpadding="0" className="table">
                            <thead>
                            <tr>
                                <th className="no">#</th>
                                <th className="desc">DESCRIPTION</th>
                                <th className="unit">UNIT PRICE</th>
                                <th className="qty">QUANTITY</th>
                                <th className="total">TOTAL</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="no">01</td>
                                <td className="desc"><h3>Website Design</h3>Creating a recognizable design solution
                                    based on
                                    the company's existing visual identity
                                </td>
                                <td className="unit">R40.00</td>
                                <td className="qty">30</td>
                                <td className="total">R1,200.00</td>
                            </tr>
                            <tr>
                                <td className="no">02</td>
                                <td className="desc"><h3>Website Development</h3>Developing a Content Management
                                    System-based Website
                                </td>
                                <td className="unit">R40.00</td>
                                <td className="qty">80</td>
                                <td className="total">R3,200.00</td>
                            </tr>
                            <tr>
                                <td className="no">03</td>
                                <td className="desc"><h3>Search Engines Optimization</h3>Optimize the site for search
                                    engines (SEO)
                                </td>
                                <td className="unit">R40.00</td>
                                <td className="qty">20</td>
                                <td className="total">R800.00</td>
                            </tr>
                            <tr>
                                <td className="no">04</td>
                                <td className="desc"><h3>Web Hosting</h3>Hosting the website (for the the first 2weeks
                                    or
                                    so...)
                                </td>
                                <td className="unit">R0.00</td>
                                <td className="qty">01</td>
                                <td className="total">R00.00</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="2">SUBTOTAL</td>
                                <td>R5,200.00</td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="2">VAT 25%</td>
                                <td>R1,300.00</td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="2">GRAND TOTAL</td>
                                <td>R6,500.00</td>
                            </tr>
                            </tfoot>
                        </table>
                        <div id="thanks">Thank you!</div>
                        <div id="notices">
                            <div>NOTICE:</div>
                            <div className="notice">This is an automatically generated invoice and is valid without a
                                signature of seal.
                            </div>
                        </div>
                    </main>
                </div>);
        }
    }
}

// GetInvoice.propTypes = propTypes;

export default GetInvoice;



// WEBPACK FOOTER //
// ./src/components/GetInvoice.js